import styled from "styled-components";

export const TableContainer = styled.div<{ disableheader: boolean; headerMarginRight?: string }>`
  margin-top: ${(props) => (props.disableheader ? "16px" : "")};
  padding-top: ${(props) => (props.disableheader ? "" : "8px")};

  .auto-complete-select {
    width: 100% !important;
  }

  .ant-select-in-form-item {
    min-width: 100% !important;
  }

  .ant-btn {
    position: unset !important;
  }

  .table-title {
    font-weight: 500 !important;
    font-size: 20px;
    line-height: 32px;
    font-style: normal;
    color: #353d48;
  }

  .ant-tabs-nav-wrap {
    background: #f9fbfd;
    border: 1px solid #d9e3f0;
  }

  .table_filter_header_background {
    background: transparent !important;
    padding: 0 24px;
    margin-bottom: 6px;

    .layout-button {
      padding-right: 16px;
    }
  }

  .row-data {
    :last-child {
      border-bottom: 1px solid;
    }
  }

  .virtuoso-grid-list {
    margin: 16px 16px 0 16px;
  }

  .column-resizer {
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    height: 25px;
    padding-right: 5px;
    margin-right: -1px;

    :hover {
      background: #38d379;
    }
  }

  .column-headers {
    .ant-typography {
      :first-letter {
        text-transform: uppercase;
      }
      max-width: 100%;
    }
  }

  .table {
    border-spacing: 0;
    .odd {
      background: #fff !important;
    }

    .even {
      background: #fff !important;
    }

    thead > tr {
      margin-bottom: -3px;
    }

    tr {
      background: #fff;
      border-color: rgba(0, 0, 0, 0.06) !important;

      .fixed-colum {
        border-right: 1px solid rgba(0, 0, 0, 0.06) !important;
      }

      .th {
        border-color: rgba(0, 0, 0, 0.06) !important;
        background: #fafafa;
        padding-left: 8px;
        .ant-typography {
          font-size: unset !important;
          font-weight: bold;
          color: #000000;
        }
      }
    }

    td,
    th,
    .ant-radio-button,
    .ant-typography,
    .ant-btn,
    .ant-form-item-label,
    .ant-select {
      font-size: ${(props) => props.theme.fontSizeSM}px !important;
    }

    .table-header,
    .td {
      :first-child {
        padding-left: 24px !important;
      }
    }

    .thead {
      tr {
        border-top: 1px solid rgba(0, 0, 0, 0.06) !important;
        position: fixed;
      }
    }
  }

  .sort-container {
    margin-bottom: 8px;
  }

  .header-container {
    padding: 24px;
  }

  .filter-item {
    background: transparent !important;
    border: 1px solid #d9e3f0;
    color: #353d48;
  }

  .ant-empty-description {
    margin-bottom: 0.5em;
    color: #353d48;
    line-height: 1.4;
  }
`;
